var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('common-header')],1),_c('el-container',[_c('sidebar'),_c('el-container',[_c('el-main',{attrs:{"id":"mainContainer"}},[_c('tabNav'),_c('div',{staticClass:"centerArea"},[_c('keep-alive',{attrs:{"include":_vm.catchComponents}},[_c('router-view')],1)],1)],1),_c('reminder')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }